import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Detect if running inside Capacitor (APK) or web browser.
// In Capacitor, assets are at root '/'; on web they're at '/web/'
const isNativeApp = window.location.hostname === 'localhost' && !window.location.pathname.startsWith('/web');
const basename = isNativeApp ? '/' : '/web';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register Service Worker for PWA support (web only, not Capacitor)
if (!isNativeApp && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/web/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}
